import React from 'react';
import StickyLabel from 'components/Flux/Shared/StickyLabel';
import { MonthlyData, NA_LABEL } from 'helper/flux/automatic';
import './index.scss';

type TableData = MonthlyData;
interface RowData {
  label: string,
  values: string[],
}

export function displayValue(value: number, percentView: boolean) {
  if (value) {
    return percentView ? new Intl.NumberFormat('en', {
      style: 'percent', minimumIntegerDigits: 2, maximumFractionDigits: 1,
    }).format(value) : value.toFixed(1);
  }
  return NA_LABEL;
}

export default function FluxAutomaticGeneralTable({
  data, tableLabel, percentView = false, lastColAsPercent = false, stickyRowLabel = false,
}: {
  data: TableData | undefined,
  tableLabel: string,
  percentView?: boolean,
  lastColAsPercent?: boolean,
  /** Congela a coluna de rótulo com teto de largura. Só o mobile passa — desktop segue igual. */
  stickyRowLabel?: boolean,
}) {
  const rowLabels = data?.rowLabels ?? [];
  const colLabels = data?.colLabels ?? [];
  const dataValues = (data?.values || [[]])
    .map((rowValues) => rowValues.map(
      (value, index) => (
        displayValue(value, percentView || (lastColAsPercent && index === rowValues.length - 1))
      ),
    ));
  const expectedDataResponse = {
    rowLabels,
    colLabels,
    values: dataValues,
  };

  const rows: RowData[] = [];
  expectedDataResponse.rowLabels.forEach((rowLabel, index) => {
    const values = expectedDataResponse.values[index];
    rows.push({
      label: rowLabel,
      values,
    });
  });

  const tableClass = [
    'table',
    stickyRowLabel ? 'sticky-table-col-row sticky-table-capped' : '',
  ].filter(Boolean).join(' ');

  return (
    <table className={tableClass}>
      <thead>
        <tr>
          <th>
            {stickyRowLabel
              ? <StickyLabel text={tableLabel} />
              : tableLabel}
          </th>
          {expectedDataResponse
            .colLabels
            .map((colLabel) => (
              <th
                scope="col"
                className="flux-col-label"
                key={`${colLabel}`}
              >
                {colLabel}
              </th>
            ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((rowData) => (
          <tr key={rowData.label}>
            <th scope="row" className="flux-row-label">
              {stickyRowLabel
                ? <StickyLabel text={rowData.label} />
                : rowData.label}
            </th>
            {rowData.values.map((value, index) => (
              <td
                className="flux-value-cell"
                key={`${rowData.label}-${colLabels[index]}-${value}`}
              >
                {value}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
